// extracted by mini-css-extract-plugin
module.exports = {"root":"avatar-icon_root__6FrCG","tooltipText":"avatar-icon_tooltipText__qT9rP","link":"avatar-icon_link__cFoO2","button":"avatar-icon_button__gJvZE"};